<template>
  <v-card
    class="relative"
    color="transparent"
    elevation="0"
  >
    <v-expand-x-transition>
      <section
        v-if="!hideSidebar"
        class="d-flex flex-column"
        style="gap: 16px;"
        :style="`width: ${$vuetify.breakpoint.lgAndUp ? '330px' : '100%'};`"
      >
        <!-- :class="{ 'd-flex flex-column' : !hideSidebar }" -->
        <template
          v-for="(facet, index) in filtersConfig"
        >
          <v-card
            :key="index"
            :ref="`facet${facet.attribute}`"
            elevation="0"
            class="transport overflow-hidden"
            style="width: 100%; border-radius: 10px;"
          >
            <!-- <v-skeleton-loader
              :loading="$store.state.loading"
              :type="`card-heading, divider, list-item@${facet.values.length}`"
            > -->
            <v-card-actions
              class="grey lighten-2"
            >
              <h4 class="pl-4 overline font-weight-black text-no-wrap">{{ facet.label }}</h4>
              <v-spacer />
              <v-btn icon @click="facet.show = !facet.show">
                <v-icon>
                  {{
                    facet.show ? "mdi-chevron-up" : "mdi-chevron-down"
                  }}
                </v-icon>
              </v-btn>
            </v-card-actions>
            <v-divider />
            <v-expand-transition>
              <div v-show="facet.show">
                <div class="pa-2 mt-2">
                  <component
                    :is="getComponent(facet.component)"
                    :name="facet.attribute"
                    :attribute="facet.attribute"
                    :items="facet.values"
                    :hide-count="hideCount || facet.hideCount"
                    :checkbox-default-value-labels="facet.checkboxDefaultValueLabels"
                    :is-multiple="facet.isMultiple"
                  />
                </div>
              </div>
            </v-expand-transition>
            <!-- </v-skeleton-loader> -->
          </v-card>
        </template>
        <v-divider
          class="mx-4"
          inset
          vertical
        />
      </section>
    </v-expand-x-transition>
  </v-card>
</template>

<script setup>
import { defineProps } from 'vue';

import CheckBoxes from '@/components/facets/CheckBoxes.vue';
import RadioBoxes from '@/components/facets/RadioBoxes.vue';
import Date from '@/components/facets/Date.vue';

defineProps({
  filtersConfig: { type: Array, default: () => [] },
  hideSidebar: { type: Boolean, default: false },
  hideCount: { type: Boolean, default: false }
});

const getComponent = component => {
  switch (component) {
    case 'checkbox':
      return CheckBoxes;

    case 'radiobox':
      return RadioBoxes;

    case 'Date':
      return Date;

    default:
      console.info('No facet defined!');
      break;
  }
  return null;
};
</script>
